import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filtro from 'containers/Relatorios/ListarRequerimentos/Filtro';
import Grid from 'containers/Relatorios/ListarRequerimentos/Grid';
import TitlePage from 'components/TituloPage';
import { formatterFiltroRelatorioListaRequerimentosFrontToBack } from 'utils/formatter/filtro';
import * as S from './styles';
import * as Style from 'components/Style';
import { privateRoot } from 'routes/paths';
import {
  fetchDownloadRelatorioRequerimentos,
  fetchGetRelatorioListarRequerimentosByFilter,
} from 'store/fetchActions/fetchRelatorios';
import { duckRelatorioTodosRequerimentos } from 'store/ducks/relatorios';

export default function PageListarRequerimentos() {
  const dispatch = useDispatch();

  const dadosGrid = useSelector(state => state.relatorios.todosRequerimentos?.list);

  const [filtroSelecionado, setFiltroSelecionado] = useState({});

  React.useEffect(() => {
    dispatch(duckRelatorioTodosRequerimentos({}));
  }, [dispatch]);

  const handlePesquisar = (filtro, page = 1, pageSize = 10) => {
    const dadosFormatados = formatterFiltroRelatorioListaRequerimentosFrontToBack(filtro);
    dispatch(fetchGetRelatorioListarRequerimentosByFilter(dadosFormatados, page, pageSize));
    setFiltroSelecionado(filtro);
  };

  const exportarRelatorio = () => {
    const dadosFormatados = formatterFiltroRelatorioListaRequerimentosFrontToBack(filtroSelecionado);
    dispatch(fetchDownloadRelatorioRequerimentos(dadosFormatados, 'Relatório de Requerimentos FAS'));
  };

  return (
    <S.Page>
      <TitlePage textTitle="Relatório - Listar Requerimentos" backPage={privateRoot} />
      <Filtro
        dadosGrid={dadosGrid}
        filtroInicial={filtroSelecionado}
        salvarFiltro={setFiltroSelecionado}
        funcExportarRelatorio={exportarRelatorio}
        handlePesquisar={handlePesquisar}
      />
      <S.ContainGrid>
        <Style.GlobalCard>
          <Grid filtros={filtroSelecionado} handlePesquisar={handlePesquisar} />
        </Style.GlobalCard>
      </S.ContainGrid>
    </S.Page>
  );
}
